import { Container, Col } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import logo from "/Users/seansaliva/Desktop/web-apps/tcrracing/client/src/images/tcr-racing-logo.png";
import "./navigation.css";
import { Link } from "react-router-dom";

const Navigation = () => {
  return (
    <>
      {["lg"].map((expand) => (
        <Navbar
          key={expand}
          bg="dark-a"
          expand={expand}
          className="fixed-top mb-3"
        >
          <Container fluid className="p-4">
            <Col xs={9} lg={2} className="text-start">
              <Navbar.Brand href="/">
                <img
                  src={logo}
                  className="img-fluid logo"
                  alt="TCR Racing Logo"
                />
              </Navbar.Brand>
            </Col>
            <Col xs={3} lg={10}>
              <Navbar.Toggle
                className="bg-light me-2"
                aria-controls={`offcanvasNavbar-expand-${expand}`}
              />
              <Navbar.Offcanvas
                id={`offcanvasNavbar-expand-${expand}`}
                aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                placement="end"
                className="bg-dark"
              >
                <Offcanvas.Header
                  closeButton
                  className="btn-close-white"
                ></Offcanvas.Header>
                <Offcanvas.Body>
                  <Nav className="justify-content-end flex-grow-1 pe-3 text-white fw-bold">
                    <Link className="link" exact to="/">
                      HOME
                    </Link>
                    <Link className="link" to="/Bio">
                      BIO
                    </Link>
                    <Link className="link" to="/News">
                      NEWS
                    </Link>
                    <Link className="link" to="/Schedule">
                      SCHEDULE
                    </Link>
                    <Link className="link" to="/Partners">
                      PARTNERS
                    </Link>
                    <Link className="link" to="/DriversPage">
                      DRIVERS
                    </Link>
                    <Link className="link" to="/Sponsorships">
                      SPONSORSHIPS
                    </Link>
                    <Link className="link" to="/Contact">
                      CONTACT
                    </Link>
                    <Link className="link" to="/Shop">
                      SHOP
                    </Link>
                  </Nav>
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </Col>
          </Container>
        </Navbar>
      ))}
    </>
  );
};

export default Navigation;
